import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router';

import 'swiper/css';
import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

import { AppConfigContext } from '../contexts/AppConfigContext';

import { useScrollToTop } from '../hooks/useScrollToTop';
import { useSliderImages } from '../hooks/useSliderImages';
import { AppConfigContextType } from '../contexts/AppConfigContext.types';
import { DEFAULT_CONFIG } from '../utils/constants';
import { getConfig } from '../utils/api';

import './App.css';
import { Header } from './Header/Header';
import { Footer } from './Footer/Footer';
import { HomePage } from './HomePage/HomePage';
import { Preloader } from './Loader/Preloader';
import { PreloadImages } from './Loader/PreloadImages';
import { Portfolio } from './Portfolio/Portfolio';
import { Project } from './Project/Project';
import { Breadcrumb } from './Breadcrumb/Breadcrumb';

function App() {
  useScrollToTop();
  const sliderImages = useSliderImages();
  const [config, setConfig] = useState<AppConfigContextType | null>(null);
  const [loadingConfig, setLoadingConfig] = useState(true);
  const [loadedImages, setLoadedImages] = useState(false);
  const [paddingCalcStyle, setPaddingCalcStyle] = useState({ paddingTop: 0 });

  const isLoading = loadingConfig || !loadedImages;

  useEffect(() => {
    if (!config) {
      getConfig()
        .then((data) => setConfig(data))
        .catch((err) => {
          setConfig(DEFAULT_CONFIG);
          console.log('err', err);
        });
    }
    setTimeout(() => setLoadingConfig(false), 2400);
  }, []);

  const getPaddings = (paddings: number) =>
    setPaddingCalcStyle((prevState) => ({
      ...prevState,
      paddingTop: paddings,
    }));

  return (
    <AppConfigContext.Provider value={config}>
      <div className="template">
        <PreloadImages images={sliderImages} onLoaded={setLoadedImages} />
        <div className="w-full min-h-screen relative">
          {!isLoading ? (
            <>
              <Header getPaddings={getPaddings} />
              <Breadcrumb paddingCalc={paddingCalcStyle} />
              <Routes>
                <Route
                  path="/"
                  element={
                    <HomePage
                      sliderImages={sliderImages}
                      paddingCalc={paddingCalcStyle}
                    />
                  }
                />
                <Route
                  path="/portfolio"
                  element={<Portfolio paddingCalc={paddingCalcStyle} />}
                />
                <Route
                  path="/portfolio/:projectId"
                  element={<Project paddingCalc={paddingCalcStyle} />}
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <Footer />
            </>
          ) : (
            <>
              <Preloader />
            </>
          )}
        </div>
      </div>
    </AppConfigContext.Provider>
  );
}

export default App;
